import { ca } from '@cian/analytics';
import { ESuggestType, TSuggestType } from '@cian/geosuggest-widget';

import { TGeoValue } from '../../../packages/api-models/common/json_query';
import { EPageKind } from '../../types/page';
import { getEventCategoryFromPageKind } from '../../utils/tracking';

export function trackGeoSuggestSucceed(pageKind: EPageKind) {
  ca('eventSite', {
    category: getEventCategoryFromPageKind(pageKind),
    action: 'GeoSuggest',
    label: 'Success',
  });
}

export function trackGeoSuggestError(pageKind: EPageKind, error: string) {
  ca('eventSite', {
    category: getEventCategoryFromPageKind(pageKind),
    action: 'GeoSuggest',
    label: `Error/${error}`,
  });
}

/**
 * Название справочника для групп саджеста Циана.
 * Группа `geo` — это адреса из саджеста Яндекса, их тип известен только после геокодирования,
 * для них используется `trackYandexGeoSuggestSelect`.
 */
const CIAN_SUGGEST_TYPE_LABELS: Record<Exclude<TSuggestType, ESuggestType.geo>, string> = {
  [ESuggestType.city]: 'city',
  [ESuggestType.district]: 'district',
  [ESuggestType.regionalDistrict]: 'regional_district',
  [ESuggestType.underground]: 'metro',
  [ESuggestType.railway]: 'railways',
  [ESuggestType.road]: 'highway',
  [ESuggestType.newbuilding]: 'jk',
  [ESuggestType.village]: 'KP',
  [ESuggestType.builder]: 'builder',
  [ESuggestType.businessCenter]: 'business_center',
  [ESuggestType.shoppingCenter]: 'shopping_center',
  [ESuggestType.coworking]: 'coworking',
};

/** Название справочника для типов гео, полученных геокодированием подсказки Яндекса. */
const YANDEX_GEO_TYPE_LABELS: Record<TGeoValue['type'], string> = {
  location: 'city',
  district: 'district',
  underground: 'metro',
  railway: 'railways',
  street: 'street',
  house: 'house',
  highway: 'highway',
  newobject: 'jk',
  village: 'KP',
  builder: 'builder',
  polygon: 'polygon',
  distance: 'distance',
};

function trackGeoSuggestEvent(action: string, label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'GeoSuggest',
    action,
    label,
    page: {
      pageType: 'Home',
      siteType: 'desktop',
    },
  });
}

/** Клик в строку ГЕО-саджеста. */
export function trackGeoSuggestClick() {
  trackGeoSuggestEvent('Click', 'form');
}

/** Выбор подсказки из саджеста Циана. */
export function trackGeoSuggestSelect(suggestType: Exclude<TSuggestType, ESuggestType.geo>) {
  trackGeoSuggestEvent('Select', `${CIAN_SUGGEST_TYPE_LABELS[suggestType]}/cian`);
}

/** Выбор адресной подсказки Яндекса: тип известен только после геокодирования. */
export function trackYandexGeoSuggestSelect(geoType: TGeoValue['type']) {
  trackGeoSuggestEvent('Select', `${YANDEX_GEO_TYPE_LABELS[geoType]}/yandex`);
}
